<template>
  <div class="skip-links">
    <a href="#main" class="skip-link">{{ t('skip-links.content') }}</a>
    <NuxtLink
      class="skip-link"
      :to="localePath({ name: 'slug', params: { slug: 'kontakt' } })"
    >
      {{ t('skip-links.contact') }}
    </NuxtLink>
    <NuxtLink
      class="skip-link"
      :to="localePath({ name: 'slug', params: { slug: 'dostepnosc' } })"
    >
      {{ t('skip-links.accessibility') }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const localePath = useLocalePath()
</script>

<style lang="scss" scoped>
.skip-link {
  @include focus-visible;
  padding: 8px 10px;
  font-size: rem(14px);
  color: $pure-white;
  background-color: $light-brown-2;

  .contrast-mode & {
    color: $contrast-yellow;
    background: $contrast-black;
    outline: rem(1px) dashed $contrast-yellow;
  }

  [data-aria-hidden='true'] & {
    display: none;
  }

  .skip-links:focus-within & {
    transform: translateY(var(--skip-links-height));
  }
}

.skip-links {
  --skip-links-height: #{rem(67px)};

  position: absolute;
  top: calc(var(--skip-links-height) * -1);
  left: 0;
  z-index: z(skip-links);
  display: flex;
  gap: rem(5px);

  @include media-up(md) {
    --skip-links-height: #{rem(35px)};
  }
}
</style>
